class MobileNav {
  constructor(node) {
    this.$menuButton = node;
    // console.log(node, $(this.$menuButton).parents('.header'));
    this.$header = $(this.$menuButton).parents('.header')[0];
    this.mobileNav = document.querySelector('.js-mobile-nav');
    this.$items = this.mobileNav.querySelectorAll('.js-mobile-nav-item');

    // console.log('this.mobileNav', node, this.$header, this.mobileNav);

    this.handleItemClick = this.handleItemClick.bind(this);
    this.handleBurgerButtonClick = this.handleBurgerButtonClick.bind(this);

    this.$items.forEach(($item) => {
      $($item).click(this.handleItemClick);
    });

    $(this.$menuButton).click(this.handleBurgerButtonClick);

  }

  handleItemClick() {
    console.log(this);

    this.$menuButton.classList.toggle('is-active');
    document.body.classList.toggle('body--mobile-nav');
    document.documentElement.classList.toggle('html--fix-scroll');

    this.mobileNav.classList.add('hidden');
    this.mobileNav.classList.remove('visible');

    this.removeAnimate();
  }

  handleBurgerButtonClick() {
    // console.log('handleBurgerButtonClick', this.mobileNav);

    document.body.classList.toggle('body--mobile-nav');
    document.documentElement.classList.toggle('html--fix-scroll');
    this.$menuButton.classList.toggle('is-active');

    if (this.mobileNav.classList.contains('visible')) {
      this.mobileNav.classList.add('hidden');
      this.mobileNav.classList.remove('visible');

      this.removeAnimate();
    } else {
      this.mobileNav.classList.add('visible');
      this.mobileNav.classList.remove('hidden');

      this.initAnimate();
    }
  }

  removeAnimate() {
    const $allAnimate = this.mobileNav.querySelectorAll('.animate');

    $allAnimate.forEach($animate => {
      $animate.classList.remove('active-animate');
    });
  }

  initAnimate() {
    const $allAnimate = this.mobileNav.querySelectorAll('.animate');

    $allAnimate.forEach(($animate, idx) => {
      setTimeout(() => {
        $animate.classList.add('active-animate');
      }, 150 * (idx + 1));
    });
  }
}

export default () => {
  const $menuButtons = document.querySelectorAll('.js-menu-button');

  if (!$menuButtons.length) {
    return;
  }

  $menuButtons.forEach($menuButton => {
    new MobileNav($menuButton);
  });
};



// WEBPACK FOOTER //
// ./assets/scripts/components/mobile-nav.js